import './ajax.js';

  //==============================================
  // Nav Active
  //==============================================

// Detecta o clique e aplica a classe 'active'
const navLinks = document.querySelectorAll('.nav-link');

// Função de scroll suave
function smoothScroll(target) {
  const targetElement = document.querySelector(target);
  if (targetElement) {
    const targetPosition = targetElement.offsetTop;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const duration = 800; // Duração em milissegundos
    let start = null;

    function animation(currentTime) {
      if (start === null) start = currentTime;
      const timeElapsed = currentTime - start;
      const run = ease(timeElapsed, startPosition, distance, duration);
      window.scrollTo(0, run);
      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    }

    // Função de easing para suavizar o movimento
    function ease(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
  }
}

// Detecta o clique e aplica scroll suave + classe 'active'
navLinks.forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault(); // Previne o comportamento padrão
    
    const target = link.getAttribute('href');
    
    // Aplica classe active imediatamente
    navLinks.forEach(l => l.classList.remove('active'));
    link.classList.add('active');
    
    // Scroll suave para a seção
    smoothScroll(target);
  });
});

// Marca automaticamente conforme a rolagem da página
window.addEventListener('scroll', () => {
  let fromTop = window.scrollY + 100;
  
  navLinks.forEach(link => {
    const target = link.getAttribute('href');
    
    // Verifica se é um link âncora (começa com #)
    if (target && target.startsWith('#')) {
      const section = document.querySelector(target);
      if (section) {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        
        if (sectionTop <= fromTop && sectionTop + sectionHeight > fromTop) {
          // Remove active de todos e adiciona no link atual
          navLinks.forEach(l => l.classList.remove('active'));
          link.classList.add('active');
        }
      }
    }
  });
});

jQuery(function ($) {

    //==============================================
    // MASCARAS
    //==============================================

});

Fancybox.bind("[data-fancybox]");

AOS.init();

// Slider de Cards
const slideDescription = new Swiper(".slideDescripiton", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
      delay: 20000,
      disableOnInteraction: false
      }
    });      

// Slider de Cards
const swiperCards = new Swiper('.card-slider', {
  loop: true,
  slidesPerView: 2,        // ✅ Mobile first: 2 itens
  spaceBetween: 20,        // ✅ Espaço menor para mobile
  navigation: {
    nextEl: '.card-next',
    prevEl: '.card-prev',
  },
  breakpoints: {
    // Mobile: 2 itens (até 479px)
    480: {                 // ✅ A partir de 480px: 3 itens
      slidesPerView: 3,
      spaceBetween: 20
    },
    768: {                 // ✅ Tablet: 4 itens
      slidesPerView: 4,
      spaceBetween: 24
    },
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false
  }
});

const swiperGallery = new Swiper('.mySwiper', {
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  slidesPerView: "auto",
  spaceBetween: 20,
  navigation: {
    nextEl: '.gallery-next',
    prevEl: '.gallery-prev'
  },
  autoplay: {
    delay: 8000,
    disableOnInteraction: false
  },
  breakpoints: {
    0: {
      autoHeight: true, // ativa no mobile
    },
    769: {
      autoHeight: false,
    },
  },
});

// força recalcular altura depois que as imagens terminarem de carregar
window.addEventListener('load', () => {
  swiperGallery.update();
  swiperGallery.updateAutoHeight();
});

document.addEventListener("click", (e) => {
  const playBtn = e.target.closest(".play-overlay");
  if (!playBtn) return;

  const videoContainer = playBtn.closest(".video");
  const videoId = videoContainer.dataset.videoId;

  // cria o iframe com autoplay
  const iframe = document.createElement("iframe");
  iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
  iframe.allow = "autoplay; encrypted-media; picture-in-picture";
  iframe.allowFullscreen = true;
  iframe.className = "image-2";

  // limpa o conteúdo e insere o iframe
  videoContainer.innerHTML = "";
  videoContainer.appendChild(iframe);
});

/**
 * Integrated Script
 */

/**
 * INTEGRAÇÃO G4FLEX - FORMATO ESTRITO DO PRINT (CORRIGIDO)
 */

// 1. Ouvinte do Evento (O "Gatilho")
document.addEventListener('wpcf7mailsent', function(event) {
    console.log("Form Submission Detected. Initializing...");

    // Capturamos o formulário exato que disparou o evento
    const $currentForm = jQuery(event.target);

    // CHAMADA IMPORTANTE: Passamos o formulário para a função
    handleIntegrations($currentForm); 
}, false);

// 2. Função de Integração (O "Envio")
async function handleIntegrations($form) {
    // Agora o $form não será mais 'undefined'
    const rawName  = $form.find('[name="nome"]').val();
    const rawEmail = $form.find('[name="email"]').val();
    const rawPhone = $form.find('[name="telefone"]').val().replace(/\D/g, '');

    // Payload seguindo fielmente a estrutura da sua imagem técnica
    const leadPayload = {
        "responsibleLogin": "adm",
        "name": rawName,
        "email": rawEmail,
        "phone": "55" + rawPhone,
        "origem_lead": "LP Exclusive Tianguá",
        "empreendimento": "Conviver Tianguá",
        "stageId": 1,
    };

    try {
        await jQuery.ajax({
            url: crmSettings.leadBaseUrl + crmSettings.recordTypeId,
            type: 'POST',
            contentType: 'application/json',
            headers: { "Authorization": "Bearer " + crmSettings.token },
            data: JSON.stringify(leadPayload)
        });

        console.log("✅ Sucesso no formato do print!");
        if (typeof window.openPdfPopup === "function") window.openPdfPopup();

    } catch (error) {
        console.error("❌ Erro na integração.");
        if (error.responseJSON) {
            console.log("Mensagem do CRM:", error.responseJSON);
        }
    }
}

/**
 * UI Logic (Popup & Download)
 */
document.addEventListener('DOMContentLoaded', function() {
    const popup = document.getElementById('pdf-popup');
    const popupContent = document.querySelector('.popup-content');
    const closeBtn = document.getElementById('close-popup-btn');
    const downloadBtn = document.getElementById('download-pdf-btn');
    
    const pdfUrl = 'exemple.com.br/pdf'; 
    const pdfFileName = 'presentation.pdf';

    window.openPdfPopup = function() {
        if (!popup) return;
        popup.style.display = 'block';
        popup.classList.add('fade-in');
        popupContent?.classList.add('scale-in');
    };

    function closePdfPopup() {
        if (!popup) return;
        popup.classList.remove('fade-in');
        popup.classList.add('fade-out');
        setTimeout(() => {
            popup.style.display = 'none';
            popup.classList.remove('fade-out');
        }, 300);
    }

    function forceDownload(url, filename) {
        fetch(url)
            .then(res => res.blob())
            .then(blob => {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.click();
                window.URL.revokeObjectURL(link.href);
            })
            .catch(() => window.open(url, '_blank'));
    }

    if (closeBtn) closeBtn.addEventListener('click', closePdfPopup);
    if (downloadBtn) downloadBtn.addEventListener('click', () => {
        closePdfPopup();
        forceDownload(pdfUrl, pdfFileName);
    });

    popup?.addEventListener('click', (e) => { if (e.target === popup) closePdfPopup(); });
});